import actions from './store/actions';
import mutations from './store/mutations';
import state from './store/state';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
